import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createElementVNode as _createElementVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-166dfda0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["target"]
const _hoisted_2 = { key: 2 }

import Breadcrumb from "primevue/breadcrumb";

export default /*#__PURE__*/_defineComponent({
  __name: 'BreadCrumbs',
  props: {
    items: {}
  },
  setup(__props: any) {



const reload = () => {
  location.reload();
};

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_unref(Breadcrumb), { model: _ctx.items }, {
    item: _withCtx(({ item, props }) => [
      _createElementVNode("div", _mergeProps({
        target: item.target
      }, props.action), [
        (item.route)
          ? (_openBlock(), _createBlock(_component_RouterLink, {
              key: 0,
              to: { name: item.route }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.label), 1)
              ]),
              _: 2
            }, 1032, ["to"]))
          : (item.reload)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                onClick: reload
              }, _toDisplayString(item.label), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(item.label), 1))
      ], 16, _hoisted_1)
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})